module.exports = __webpack_public_path__ + "media/images/linkedin-white@2x-ae89e1b74756604aa1db9c9f74e7771b.png";